export default "__VITE_ASSET__6774f422__"